import { useCallback, useSyncExternalStore } from 'react';
import type { MessengerMessage, MessengerPinnedMessage } from '@/api/client';
import {
  getDirectThreadSnapshot,
  subscribeDirectThread,
} from '@/components/Messenger/cache/directThreadCacheStore';

export type DirectThreadMessagesSnapshot = {
  messages: MessengerMessage[];
  pinnedMessages: MessengerPinnedMessage[];
  /** @deprecated используйте hasMoreOlder */
  hasMore: boolean;
  hasMoreOlder: boolean;
  hasMoreNewer: boolean;
};

const EMPTY: DirectThreadMessagesSnapshot = Object.freeze({
  messages: [],
  pinnedMessages: [],
  hasMore: false,
  hasMoreOlder: false,
  hasMoreNewer: false,
});

const cacheByThread = new Map<string, DirectThreadMessagesSnapshot>();

function getSnapshot(threadId: string | null): DirectThreadMessagesSnapshot {
  if (!threadId) return EMPTY;
  const raw = getDirectThreadSnapshot(threadId);
  const prev = cacheByThread.get(threadId);
  if (
    prev &&
    prev.messages === raw.messages &&
    prev.pinnedMessages === raw.pinnedMessages &&
    prev.hasMoreOlder === raw.hasMoreOlder &&
    prev.hasMoreNewer === raw.hasMoreNewer
  ) {
    return prev;
  }
  const next: DirectThreadMessagesSnapshot = {
    messages: raw.messages,
    pinnedMessages: raw.pinnedMessages,
    hasMore: raw.hasMoreOlder,
    hasMoreOlder: raw.hasMoreOlder,
    hasMoreNewer: raw.hasMoreNewer,
  };
  cacheByThread.set(threadId, next);
  return next;
}

export function useDirectThreadMessages(threadId: string | null): DirectThreadMessagesSnapshot {
  return useSyncExternalStore(
    useCallback((onChange) => subscribeDirectThread(threadId, onChange), [threadId]),
    () => getSnapshot(threadId),
    () => EMPTY
  );
}
